// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1VnHl","amount":"Amount_amount__3mLXD","tip":"Amount_tip__bG7jR","tipHeader":"Amount_tipHeader__1gvhu","tipsWrap":"Amount_tipsWrap___FhEf"};